// ConfirmDialog.tsx — shared MUI confirmation dialog for the Add New Product
// footer actions (Start over / Save draft / Cancel). Mirrors the pattern in
// integrations/UnlinkConfirmDialog.tsx.
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    destructive?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    /** Backdrop/escape close. Defaults to onCancel. */
    onClose?: () => void;
}

export function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel,
    cancelLabel,
    destructive = false,
    onConfirm,
    onCancel,
    onClose
}: ConfirmDialogProps) {
    return (
        <Dialog open={open} onClose={onClose ?? onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{cancelLabel}</Button>
                <Button color={destructive ? "error" : "primary"} variant="contained" onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
